import { Component, type ErrorInfo, type ReactNode } from 'react'
import { resolveLocale, translate } from '../lib/i18n'

export class AppErrorBoundary extends Component<{children:ReactNode},{failed:boolean}> {
  state={failed:false}
  static getDerivedStateFromError(){return {failed:true}}
  componentDidCatch(error:Error,info:ErrorInfo){console.error('Clash Cards render failure',error,info.componentStack)}
  render(){
    if(this.state.failed){const locale=resolveLocale(localStorage.getItem('clash_cards_locale'));return <main className="fatal-error"><h1>Clash Cards</h1><p>{translate(locale,'fatalError')}</p><button onClick={()=>window.location.reload()}>{translate(locale,'reloadApp')}</button></main>}
    return this.props.children
  }
}
